export { default as HomePage } from "./HomePage/HomePage";
export { default as TeamPage } from "./TeamPage/TeamPage";
export { default as EventPage } from "./EventPage/EventPage";
export { default as FaqPage } from "./FaqPage/FaqPage";
export { default as BlogListPage } from "./BlogListPage/BlogListPage";
export { default as BlogPage } from "./BlogPage/BlogPage";
